/* src/app/layout/main-layout/main-layout.component.scss */
.sub-menu-icon img {
  width: 16px;
  height: auto;
}
.main-container {
  height: 100%;
  width: 100%;
  background: url(/assets/images/main-layout/capstone-pink-purple-bg.jpg) no-repeat;
  background-size: cover !important;
  overflow: hidden;
}
.main-container.pink-purple {
  background: url(/assets/images/main-layout/capstone-pink-purple-bg.jpg) no-repeat;
}
.main-container.blue-bg {
  background: url(/assets/images/main-layout/capstone-patient-blue-bg.jpg) no-repeat;
}
.main-container.pink-bg {
  background: url(/assets/images/main-layout/capstone-manage-pink-bg.jpg) no-repeat;
}
.main-container.rainbow-bg {
  background: url(/assets/images/main-layout/capstone-appointment-blue-bg.jpg) no-repeat;
}
.main-container.purple-bg {
  background: url(/assets/images/main-layout/capstone-ops-purple-bg.jpg) no-repeat;
}
.main-top-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 70px;
  min-height: 70px;
  background-color: rgba(255, 255, 255, 0.5);
}
.top-icon-container {
  background-color: #ffffff;
  padding: 5px 10px;
  display: flex;
  margin: 10px 0 0 0;
}
.top-icon {
  display: flex;
  align-items: center;
}
.menu-name {
  font-size: 26px;
  font-family: "Open Sans", sans-serif;
  color: #333;
  margin-left: 30px;
}
.menu-id-name {
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  font-weight: lighter;
  margin-left: 15px;
}
.menu-banner-text {
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  font-weight: lighter;
  margin-left: 5px;
  margin-top: 5px;
}
.side-nav-and-content {
  display: flex;
  flex-direction: row;
  height: 92%;
  width: 100%;
}
.main-router-outlet-content {
  width: calc(100% - 50px);
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
}
.side-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50px;
  height: 100%;
  background-color: #5bc8f9;
}
.logo {
  display: flex;
  align-items: center;
  width: 50px;
  margin-left: 12px;
}
img.logo-banner.logo-fix {
  height: 40px;
}
.menu {
  display: flex;
  flex-direction: column;
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
}
.menu-panel {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 15px 0px;
}
.menu-item {
  display: flex;
  flex-direction: column;
  flex: 0 0 50px;
  border-left: 3px solid transparent;
}
.menu-collapsed {
  position: relative;
  width: 50px;
  transition: 0.2s;
}
.menu-expanded {
  width: 260px;
  transition: 0.2s;
}
.sub-menu {
  display: flex;
  flex-direction: column;
}
.menu-item-icon-name:hover,
.sub-menu-item-icon-name:hover {
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.5);
}
.highlight {
  border-left: 5px solid #333333;
}
.mat-drawer-inner-container,
::ng-deep .search-drawer .mat-drawer-inner-container {
  overflow-x: hidden !important;
}
.search-drawer {
  width: 450px;
  display: flex;
  flex-direction: column;
}
.search-text {
  font-size: 22px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  color: #323232;
}
.search-close {
  color: #333;
  font-size: 24px;
}
.search-close:hover {
  color: #b413ba;
  cursor: pointer;
}
.search-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 6%;
}
.margin-0606 {
  margin: 0 6% 0 6%;
}
.margin-6606 {
  margin: 6% 6% 0 6%;
}
.add-patient-btn {
  margin: 0 6% 0 6%;
}
.search-box {
  margin: 0 6% 0 6%;
}
.results {
  font-size: 14px;
  font-weight: 400;
}
.patients-count {
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  color: #797979;
}
.patient-search-result {
  display: flex;
  flex-direction: column;
  margin: 2% 6% 0 6%;
}
.expansion-panel-arrow {
  height: 24px;
  width: 24px;
}
.title-arrow {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.user-details {
  margin-top: 5px;
  padding: 10px;
}
.user-name {
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
}
.user-extra-details {
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
}
.load-more {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: -2%;
}
.load-more:hover {
  cursor: pointer;
  color: #b413ba !important;
}
.load-more-text {
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
}
.load-more-img {
  width: 24px;
  height: 24px;
  transform: rotate(270deg);
}
.menu-item-icon-name {
  display: flex;
  flex-direction: row;
  flex: 0 0 50px;
}
.menu-icon {
  margin: 13px 0px 0px 10px;
  width: 22px;
}
.top-menu-icon {
  margin: 0px;
  width: 20px;
}
.main-menu-name {
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
  color: #000;
  margin: 13px 0px 0px 10px;
}
.sub-menu-item-icon-name {
  display: flex;
  flex-direction: row;
  flex: 0 0 50px;
  align-items: center;
}
.sub-menu-icon {
  margin: 0px 0px 0px 20px;
  width: 25px;
}
.sub-menu-name {
  font-size: 12px;
  font-family: "open sans", sans-serif;
  color: #000;
  margin: 0px 10px 0px 10px;
}
.sub-menu-highlight {
  background-color: rgba(255, 255, 255, 0.5);
  border-right: 4px solid #c96abf;
}
.sub-menu-highlight-empty {
  border-right: none;
}
.right-menu-bar {
  position: absolute;
  right: 20px;
  display: flex;
  float: right;
}
.list_action a {
  padding: 0 8px 0px 9px;
}
.list_action .top-icon mat-icon.mat-icon.notranslate {
  font-size: 24px;
  color: #333;
  margin: 0px;
}
.list_action .top-icon-container mat-icon.mat-icon.notranslate {
  font-size: 30px;
  color: #333;
  margin: 0px 5px;
}
::ng-deep .mat-mdc-menu-panel {
  margin-top: 15px !important;
  padding: 10px 0px;
}
.mat-mdc-menu-item {
  height: 34px;
  line-height: 0px;
}
.list_action {
  float: left;
  display: flex;
  gap: 10px;
  margin-right: 20px;
}
.user_action {
  float: right;
  height: 40px;
  width: 40px;
  border: 1px solid;
  overflow: hidden;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.user_action .mat-icon {
  font-size: 35px;
}
.user_action .user-img {
  width: auto;
  height: 50px;
}
.notification_count {
  font-size: 11px;
  font-weight: 600;
  top: 2px;
  position: relative;
  border: 1px solid;
  border-radius: 17px;
  width: 33px;
  text-align: center;
  margin: -20px 0 0 -24px;
  background: #f06285;
  color: #fff;
  height: 21px;
  opacity: 1;
  padding: 2px 2px 0px 2px;
}
.version {
  position: absolute;
  left: 10px;
  bottom: 0px;
}
.version p {
  font-size: 10px;
  line-height: 14px;
  font-family: "Open Sans", sans-serif;
  font-style: italic;
}
.menu.menu-collapsed .sub-menu-icon {
  margin: 0px 0px 0px 13px;
}
.menu.menu-collapsed .sub-menu-item-icon-name.pl-10px {
  padding-left: 2px !important;
}
@media only screen and (max-width: 1280px) {
  .side-nav-and-content {
    height: 85%;
  }
}
.filter_menu_item {
  text-decoration: none;
  color: #000;
}
.custom-modalbox {
  width: 10%;
}
.outer_item {
  padding: 10px 2px 2px 7px;
  background: #5477ac;
  border-radius: 13px;
  color: white;
  margin: 14px 0 0 5px;
  width: 31px;
}
.im-btn-wrapper {
  position: relative;
}
.im-btn-wrapper .oute_item_name {
  position: relative;
}
.im-unread-badge {
  position: absolute;
  top: -8px;
  right: -10px;
  background: #ff3b30;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  line-height: 1;
  box-sizing: border-box;
}
.menu_toggler {
  color: #5477ac;
  border-radius: 40px;
  color: white;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
  color: #5477ac;
  padding-left: 11px;
}
.top-icon-container a {
  cursor: pointer;
}
@media only screen and (max-width: 1280px) {
  .main-router-outlet-content {
    height: 98%;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .menu-name.header-part-content {
    width: 40% !important;
  }
  .header-part-content {
    width: 50% !important;
    font-size: 14pt;
    margin-left: 1%;
    display: flex;
  }
  .header-title {
    width: auto !important;
  }
  .menu-id-name {
    font-size: 12px;
    margin-left: 5px;
  }
  .menu-banner-text {
    margin-left: 0px;
    margin-top: 0px;
  }
  .right-menu-bar {
    right: 20px;
  }
  .top-icon-container {
    padding: 5px 6px;
    margin: 5px 0 0 0;
  }
  .list_action {
    margin-right: 12px;
  }
  .list_action a {
    padding: 0px 5px 0px 5px;
  }
  .top-menu-icon {
    margin: 0px;
    width: 18px;
  }
  .notification_count {
    margin: -12px 0 0 -11px;
    border-radius: 14px;
    height: 17px;
    opacity: 1;
    font-size: 7px;
    top: 2px;
    padding: 0px 0px 0px 0px;
    width: 16px;
  }
  .user_action {
    height: 35px;
    width: 35px;
  }
  .user_action .user-img {
    height: 40px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  img.logo-banner.logo-fix {
    height: 35px;
  }
  .header-part-content {
    width: 50% !important;
    font-size: 14pt;
    margin-left: 1%;
    display: flex;
  }
  .header-title {
    width: auto !important;
  }
  .menu-id-name {
    font-size: 12px;
    margin-left: 5px;
  }
  .menu-banner-text {
    margin-left: 0px;
    margin-top: 0px;
  }
  .right-menu-bar {
    right: 20px;
  }
  .top-icon-container {
    padding: 5px 6px;
    margin: 5px 0 0 0;
  }
  .list_action {
    margin-right: 12px;
  }
  .list_action a {
    padding: 0px 5px 0px 5px;
  }
  .top-menu-icon {
    margin: 0px;
    width: 18px;
  }
  .notification_count {
    margin: -12px 0 0 -11px;
    border-radius: 14px;
    height: 17px;
    opacity: 1;
    font-size: 7px;
    top: 2px;
    padding: 0px 0px 0px 0px;
    width: 16px;
  }
  .user_action {
    height: 35px;
    width: 35px;
  }
  .user_action .user-img {
    height: 40px;
  }
}
@media only screen and (min-device-width: 820px) and (max-device-width: 1180px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {
  img.logo-banner.logo-fix {
    height: 35px;
  }
  .header-part-content {
    width: 50% !important;
    font-size: 14pt;
    margin-left: 1%;
    display: flex;
  }
  .header-title {
    width: auto !important;
  }
  .menu-id-name {
    font-size: 12px;
    margin-left: 5px;
  }
  .menu-banner-text {
    margin-left: 0px;
    margin-top: 0px;
  }
  .right-menu-bar {
    right: 20px;
  }
  .top-icon-container {
    padding: 5px 6px;
    margin: 5px 0 0 0;
  }
  .list_action {
    margin-right: 12px;
  }
  .list_action a {
    padding: 0px 5px 0px 5px;
  }
  .top-menu-icon {
    margin: 0px;
    width: 18px;
  }
  .notification_count {
    margin: -12px 0 0 -11px;
    border-radius: 14px;
    height: 17px;
    opacity: 1;
    font-size: 7px;
    top: 2px;
    padding: 0px 0px 0px 0px;
    width: 16px;
  }
  .user_action {
    height: 35px;
    width: 35px;
  }
  .user_action .user-img {
    height: 40px;
  }
}
@media (min-width: 1280px) and (max-width: 1919.98px) {
  .menu-name.header-part-content {
    width: 40% !important;
  }
  .header-part-content {
    width: 50% !important;
    font-size: 14pt;
    margin-left: 1%;
    display: flex;
  }
  .header-title {
    width: auto !important;
  }
  .menu-id-name {
    font-size: 12px;
    margin-left: 5px;
  }
  .menu-banner-text {
    margin-left: 0px;
    margin-top: 0px;
  }
}
/*# sourceMappingURL=main-layout.component.css.map */
